import { BancaConfigTypes } from "./types/banca-config-types";

export const BancaConfig: BancaConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
